import React from 'react';

const UserDashboard = () => {
    return <h1>Welcome to the User Dashboard</h1>;
};

export default UserDashboard;
